export enum PAGE {
    FORM = 'form',
    RESULTS = 'results',
    DETAILS = 'details',
    COMPARE = 'compare',
    APPLICANT_INFORMATION = 'applicant-information',
    PRODUCER_EMAIL_ENTRY = 'producer-email-entry',
}
